import { ConversionMutationApplication } from '__generated__/api';
import { http } from '../http';

export interface CollateralData {
  commercialLabel: string;
  loanNumber: string;
  valuationType: string;
  value: string;
  date: string;
  formFile: File;
}

export async function saveMutationApplication(formData: any) {
  const url = '/api/mutations/save';

  const response = await http({
    url: url,
    method: 'POST',
    data: JSON.stringify(formData),
  });
  return response;
}

export async function saveAndValidateMutationApplication(formData: any) {
  const url = '/api/mutations/save';

  const response = await http({
    url: url,
    method: 'POST',
    data: JSON.stringify(formData),
  });
  return response;
}

export async function getMutationApplication(id: number): Promise<ConversionMutationApplication> {
  const url = `/api/mutations/conversion/${id}`;
  const response = await http({
    url: url,
    method: 'GET',
  });
  return response.data;
}

export async function submitMutationApplication(formData: any) {
  const url = '/api/mutations/submit';

  const response = await http({
    url: url,
    method: 'POST',
    data: JSON.stringify(formData),
  });
  return response;
}

export async function getTechnicalProductsForConvertLoan(
  commercialLabel: string,
  loanNumber: number
) {
  const url = `/api/v1/lenders/${commercialLabel}/loans/${loanNumber}/mutation/convertraiseenum/products`;
  return http.get(url);
}

export async function submitCollateralApplication(collateralData: CollateralData) {
  const formData = new FormData();
  formData.append('commercialLabel', collateralData.commercialLabel);
  formData.append('loanNumber', collateralData.loanNumber);
  formData.append('valuationType', collateralData.valuationType);
  formData.append('value', collateralData.value);
  formData.append('date', collateralData.date);
  formData.append('formFile', collateralData.formFile);

  const response = await http({
    url: '/api/v1/collateral/valuation',
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  });

  return response;
}
